module.exports = __webpack_public_path__ + "../resources/images/outlook-logo-white-61488c5fb2de97fd049242683d4429f7.png";